export enum IntegrationResourceType {
  Payer = "Payer",
  Payee = "Payee"
}
